export default function availableDocumentTypesResponse(response) {
    return response.map(i => ({
        label: `${i.module} / ${i.category_name} / ${i.document_type_name}`,
        value: i.document_type_id,
        isModal: i?.attributes?.modal,
        documentTypeName: i?.document_type_name,
        attributes: i?.attributes ?? {},
    }));
}